module.exports = __webpack_public_path__ + "static/media/bgImg.1daed578.jpg";